import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Auth } from './Auth';
import { Login } from './Login';
import { PrivateLayout } from './PrivateLayout';
import { PrivateRoute } from './PrivateRoute';
import { RemoveTrailingSlash } from './RemoveTrailingSlash';

export const Router = () => {
  return (
    <BrowserRouter>
      <RemoveTrailingSlash />
      <Switch>
        <Route path="/login">
          <Login />
        </Route>

        {/*
            After login the user will get redirected to the path "/auth"
            Auth component will check for any Auth0 Error 
            otherwise it will redirect to the homepage 
        */}
        <Route path="/auth">
          <Auth />
        </Route>

        {/* PrivateRoute will prevent users not authenticated to go to all Private Layout */}
        <PrivateRoute path="*">
          <PrivateLayout />
        </PrivateRoute>
      </Switch>
    </BrowserRouter>
  );
};
